import { useQuery } from '@tanstack/react-query';
import type { GetSubscriptionResponse } from '@repo/shared-types';
import { api } from '../lib/api';

export function useSubscription({ pollUntilActive = false } = {}) {
  const query = useQuery<GetSubscriptionResponse>({
    queryKey: ['subscription'],
    queryFn: async () => {
      const { data } = await api.get<GetSubscriptionResponse>(
        '/api/v1/billing/subscription',
      );
      return data;
    },
    refetchInterval: (q) => {
      if (!pollUntilActive) return false;
      const status = q.state.data?.subscription?.status;
      return status === 'active' || status === 'trialing' ? false : 2000;
    },
  });

  const subscription = query.data?.subscription ?? null;
  const plan = subscription?.plan ?? 'free';
  const isActive = subscription?.status === 'active';
  const isTrialing = subscription?.status === 'trialing';

  return {
    subscription,
    plan,
    isActive,
    isTrialing,
    isLoading: query.isLoading,
    error: query.error,
  };
}
 